import Ajax from '@utils/ajax';

export default {
  get(id, options = {}) {
    return Ajax.get({
      url: `/mutual_suggested_follows/${id}`,
      ...options,
    });
  },

  search(q, next_max_id = null, options = {}) {
    return Ajax.get({
      url: `/mutual_suggested_follows/search?query=${q}${next_max_id ? `&next_max_id=${next_max_id}` : ''}`,
      ...options,
    });
  },

  searchStats(options = {}) {
    return Ajax.get({
      url: `/mutual_suggested_follows/search_stats`,
      ...options,
    });
  },

  dmLink(username, options = {}) {
    return Ajax.get({
      url: `/mutual_suggested_follows/dm_link?username=${username}`,
      ...options,
    });
  },
};
